export const name = 'SelectAddressController';
export default function SelectAddressController(
  $mdDialog,
  $gzAnalytics,
  $gzGoogleMaps,
  addresses
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;
  vm.loading = true;

  vm.mapOptions = {
    hideNameField: true,
    displayMode: true,
    onMapLoaded: handleMapLoaded,
  };

  vm.selectAddress = selectAddress;
  vm.addressChanged = addressChanged;
  vm.cancel = cancel;

  activate();

  ////////////////////////
  function activate() {
    if (vm.addresses && vm.addresses.length > 0) {
      vm.address = vm.addresses[0];
      vm.mapOptions.address = vm.address;
    }
    vm.loading = false;
  }

  function selectAddress() {
    let address = {
      address: vm.address,
      timezone: vm.timeZone,
    };
    $mdDialog.hide(address);
  }

  function addressChanged() {
    if (vm.mapOptions.api) {
      vm.mapOptions.api.setAddress(vm.address).then(place => {
        vm.addressDisplay = place ? place.formatted_address : $gzGoogleMaps.getFormattedAddress(vm.address);
      });
    }
  }

  function handleMapLoaded(place) {
    vm.addressDisplay = place ? place.formatted_address : $gzGoogleMaps.getFormattedAddress(vm.address);
  }

  function cancel() {
    $mdDialog.cancel();
    $gzAnalytics.eventCancel('Select address', {});
  }
}
